<template>
    <div class="numslider">
        <div class="numslider__title">
            {{title}}
        </div>
        <div class="numslider__value">
            {{view}} {{postfix}}
        </div>
        <div class="numslider__slider" ref="slider" :value="value"></div>
        <div class="numslider__anchors">
            <span class="anchor filled at-start" @click="setValue(min)">{{min | russianCurrency(postfix)}}</span>
            <span class="anchor at-end" @click="setValue(max)">{{max | russianCurrency(postfix)}}</span>
        </div>  
    </div>
</template>

<script>
    import noUiSlider from 'nouislider';
    import threeDigits from '../filters/threeDigits';
    import russianCurrency from '../filters/russianCurrency';

    export default {
        props: ['title', 'min', 'max', 'step', 'start', 'value', 'postfix', 'view'],
        data() {
            return {
                slider: {}
            }
        },
        methods: {
            setValue(value) {
                this.$refs.slider.noUiSlider.set(value);              
            }
        },
        filters: {
            russianCurrency,
            threeDigits
        },
        mounted() {
            // Init the slider       
            this.slider =
                noUiSlider.create(this.$refs.slider, {
                range: {
                    min: parseFloat(this.min),
                    max: parseFloat(this.max)
                },
                start: this.value,
                step: parseFloat(this.step),
                connect: 'lower'
            });

            // Emit event
            this.$refs.slider.noUiSlider.on('update', (values, handle) => {
                this.$emit('input', values[handle], this.slider);                 
            });            
        }
    }
</script>